import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efbf4d8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "config-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Author", -1))
const _hoisted_3 = { class: "grid p-fluid" }
const _hoisted_4 = { class: "col-12 field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Username", -1))
const _hoisted_6 = { class: "col-12 field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Avatar", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Post", -1))
const _hoisted_9 = { class: "grid p-fluid" }
const _hoisted_10 = { class: "col-12 field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Picture", -1))
const _hoisted_12 = { class: "col-12 field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Likes", -1))
const _hoisted_15 = { class: "grid p-fluid" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Avatars", -1))
const _hoisted_19 = { class: "field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First Like Username", -1))
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Number of Other Likes", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Misc", -1))
const _hoisted_24 = { class: "grid p-fluid" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Profile Avatars", -1))
const _hoisted_28 = { class: "field" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Number of Comments", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_InputText, {
          class: "p-inputtext-sm",
          modelValue: _ctx.authorUsername,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authorUsername) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_FileUpload, {
          mode: "basic",
          accept: "image/*",
          chooseLabel: "Choose Author Avatar",
          onSelect: _ctx.authorAvatarSelected
        }, null, 8, ["onSelect"])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_FileUpload, {
          mode: "basic",
          accept: "image/*",
          chooseLabel: "Choose Post Picture",
          onSelect: _ctx.postPictureSelected
        }, null, 8, ["onSelect"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_Calendar, {
          class: "p-calendar",
          modelValue: _ctx.postDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postDate) = $event)),
          dateFormat: "MM d",
          autocomplete: "off",
          inputClass: "p-inputtext-sm w-full"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_FileUpload, {
            mode: "basic",
            accept: "image/*",
            multiple: "",
            fileLimit: 3,
            chooseLabel: "Choose Like Avatars",
            onSelect: _ctx.likesAvatarsSelected
          }, null, 8, ["onSelect"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_InputText, {
            class: "p-inputtext-sm",
            modelValue: _ctx.likesFirstUserName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.likesFirstUserName) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_InputText, {
            class: "p-inputtext-sm",
            modelValue: _ctx.numberOfOtherLikes,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.numberOfOtherLikes) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _hoisted_23,
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createVNode(_component_FileUpload, {
            mode: "basic",
            accept: "image/*",
            chooseLabel: "Choose Profile Avatar",
            onSelect: _ctx.profileAvatarSelected
          }, null, 8, ["onSelect"])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createVNode(_component_InputText, {
            class: "p-inputtext-sm",
            modelValue: _ctx.numberOfComments,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.numberOfComments) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}